/* eslint-disable max-lines */
import { ModalEvent } from 'kinetic-angular';
import { AdditionalLocationListResponse, SubmitRegistrationResponse, UploadFileLabels } from '../components/registration';
import { RegistrationRequestType } from '../services/shared/shared-enums';
export const registrationPageData = {
	logo: { iconPath: '', altText: '' },
	logoutLabel: '',
	stepLabel: '',
	pageHeading: '',
	pageDescription: '',
	profileInfo: {
		logo: { iconPath: '', altText: '' },
		stepNumber: '',
		heading: '',
		description: '',
		firstName: '',
		lastName: '',
		emailAddress: '',
		phoneNumber: '',
		jobTitle: '',
		jobTitleAltText: '',
		requestedRole: { label: '', description: '' },
		requestedRoleAltText: ''
	},
	companyDetails: {
		logo: { iconPath: '', altText: '' },
		heading: '',
		description: '',
		stepNumber: '',
		companyName: '',
		addressLine1: '',
		addressLine2: '',
		address2OptionalLabel: '',
		country: '',
		city: '',
		state: '',
		stateAltText: '',
		zipCode: '',
		companyNotFoundErrorModalDescription: '',
	    companyNotFoundErrorModalHeader: ''
	},
	termsConditions: {
		logo: { iconPath: '', altText: '' },
		heading: '',
		description: '',
		stepNumber: '',
		terms: {
			disclaimer: '',
			label: '',
			tokenData: [{ name: '', text: '', url: '', isLink: '' }],
			modal: {
				heading: '',
				closeIcon: { iconPath: '', altText: '' },
				content: [''],
				agreeButtonLabel: '',
				agreedButtonLabel: '',
				disagreeButtonLabel: '',
				checkboxText: ''
			}
		},
		privacy: {
			disclaimer: '',
			label: '',
			tokenData: [{ name: '', text: '', url: '', isLink: '' }],
			modal: {
				heading: '',
				closeIcon: { iconPath: '', altText: '' },
				content: [''],
				agreeButtonLabel: '',
				agreedButtonLabel: '',
				disagreeButtonLabel: '',
				checkboxText: ''
			}
		}
	},
	privacypolicy: {
		logo: { iconPath: '', altText: '' },
		heading: '',
		description: '',
		stepNumber: '',
		terms: {
			disclaimer: '',
			label: '',
			tokenData: [{ name: '', text: '', url: '', isLink: '' }],
			modal: {
				heading: '',
				closeIcon: { iconPath: '', altText: '' },
				content: [''],
				agreeButtonLabel: '',
				agreedButtonLabel: '',
				disagreeButtonLabel: '',
				checkboxText: ''
			}
		},
		privacy: {
			disclaimer: '',
			label: '',
			tokenData: [{ name: '', text: '', url: '', isLink: '' }],
			modal: {
				heading: '',
				closeIcon: { iconPath: '', altText: '' },
				content: [''],
				agreeButtonLabel: '',
				agreedButtonLabel: '',
				disagreeButtonLabel: '',
				checkboxText: ''
			}
		}
	},
	accountType: {
		description: '',
		heading: '',
		logo: { iconPath: '', altText: '' },
		stepNumber: '',
		individualAccount: {
			label: '',
			description1: '',
			description2: '',
			tokenData: [{ name: '', text: '', url: '', isLink: '' }]
		},
		businessAccount: {
			label: '',
			description1: '',
			description2: '',
			tokenData: [{ name: '', text: '', url: '', isLink: '' }]
		}
	},
	additionalLocation: {
		locationPageDescription: {
			description1: '',
			description2: '',
			tokenData: [{ name: '', text: '', url: '', isLink: '' }]
		},
		heading1: '',
		headingOr: '',
		heading2: {
			label: '',
			iconPath: '',
			altText: ''
		},
		logo: { iconPath: '', altText: '' },
		stepNumber: '',
		primaryLocationHeading: '',
		selectLocationTableHeader: {
			companyName: '',
			address: '',
			country: '',
			selectAll: ''
		},
		uploadSuccessText: '',
		uploadSuccessSubtext: ''
	},
	submitButton: '',
	companyError: {
		messageMain: '',
		messageSub: '',
		actionMessage: '',
		phoneNumber: {
			label: '',
			value: ''
		},
		email: {
			label: '',
			value: ''
		},
		customerServiceName: '',
		address: '',
		contactDealer: {
			label: '',
			icon: ''
		}
	},
	domainInfo: {
		heading: '',
		description: '',
		stepNumber: '',
		subHeading: '',
		logo: { iconPath: '', altText: '' },
		labelPrefix: '',
		labelSuffix: ''
	}
};
export const errorCompanyInfo = {
	success: true,
	message: 'Success',
	statusCode: 200,
	data: {
		errorMessage: 'Company\'s information was not found in EIL system.',
		dealerInfo: {
			dealerName: 'Dealer1',
			phoneNumber: '000.000.0000',
			email: 'service@email.com',
			address: '123 Equipment Ave, Durham, North Carolina  12345'
		}
	}
};

export const successCompanyInfo = {
	success: true,
	message: 'Success',
	statusCode: 201,
	data: { successMessage: 'Registration form submitted, Account is pending for approval from Administrator.' }
};
export const registrationFormPayload = {
	email: 'user101@accenture.com',
	firstName: 'User',
	lastName: 'Test',
	jobTitle: 'Purchasing',
	phoneNumber: '987654321',
	accountName: 'Accenture',
	addressLine1: '34A',
	addressLine2: 'Egdewater',
	city: 'NewJersey',
	state: 'NY',
	postalCode: '07015',
	requestedRole: 'Default User',
	crmPrefill: false,
	country: 'USA'
};
export const registrationFormPayload1 = {
	email: 'user101@accenture.com',
	firstName: 'User',
	lastName: 'Test',
	jobTitle: 'Purchasing',
	phoneNumber: '987654321',
	accountName: 'Accenture',
	addressLine1: '36A',
	addressLine2: 'Egdewater',
	city: 'NewJersey',
	state: 'NY',
	postalCode: '07015',
	requestedRole: 'Default User',
	crmPrefill: false,
	country: 'USA'
};
export const registrationFormPayload2 = {
	email: 'user101@accenture.com',
	firstName: 'User',
	lastName: 'Test',
	jobTitle: 'Purchasing',
	phoneNumber: '987654321',
	accountName: 'Accenture',
	addressLine1: '34A',
	addressLine2: 'EgdeWater',
	city: 'NewJersey',
	state: 'NY',
	postalCode: '07015',
	requestedRole: 'Default User',
	crmPrefill: false,
	country: 'USA'
};
export const mockPrefillCompanyDetails = {
	addressLine1: '34A',
	addressLine2: 'Egdewater',
	companyName: 'Accenture',
  	country: 'USA',
	city: 'NewJersey',
	state: 'NY',
	zipCode: '07015'
};
export const prefillUserDetails = {
	companyDetails: {
		addressLine1: '',
		addressLine2: '',
		country: '',
		companyName: '',
		state: '',
		zipCode: '',
		city: ''
	},
	profileInformation: {
		firstName: '',
		lastName: '',
		phoneNumber: '',
		jobTitle: [{ label: '', id: '' }],
		requestedRole: [{
			description: '',
			id: '',
			name: ''
		}],
		email: ''
	},
	tempIsPrefilled: false,
	crmPrefill: true
};
export const prefillUserDetailsUsa = {
	companyDetails: {
		addressLine1: '',
		addressLine2: '',
		country: 'USA',
		companyName: '',
		state: '',
		zipCode: '',
		city: ''
	},
	profileInformation: {
		firstName: '',
		lastName: '',
		phoneNumber: '',
		jobTitle: [{ label: '', id: '' }],
		requestedRole: [{
			description: '',
			id: '',
			name: ''
		}],
		email: ''
	},
	tempIsPrefilled: false,
	crmPrefill: true
};
export const prefillUserDetailsCan = {
	companyDetails: {
		addressLine1: '',
		addressLine2: '',
		country: 'CA',
		companyName: '',
		state: '',
		zipCode: '',
		city: ''
	},
	profileInformation: {
		firstName: '',
		lastName: '',
		phoneNumber: '',
		jobTitle: [{ label: '', id: '' }],
		requestedRole: [{
			description: '',
			id: '',
			name: ''
		}],
		email: ''
	},
	tempIsPrefilled: false,
	crmPrefill: true
};
export const mockAdditionalLocationResponse: AdditionalLocationListResponse = {
	primaryLocationInfo: {
		primaryLocationGRID: '1234',
		adminLocationID: '16742',
		topLevelGrid: '1234',
		companyName: 'TRACTOR SUPPLY',
		addressLine1: '123 Equipment Ave, Suite 444',
		addressLine2: '',
		city: 'Durham',
		state: 'TX',
		zipCode: '12345',
		country: 'US'
	},
	locationList: [
		{ locationGRID: '1234', companyName: 'Company ABC', addressLine1: '123 Equipment Ave, Suite 000', city: 'Durham', state: 'TX', zipCode: '52633', country: 'US' },
		{ locationGRID: '1234', companyName: 'Company DEF', addressLine1: '123 Equipment Ave, Suite 111', city: 'Durham', state: 'NY', zipCode: '23432', country: 'USA' },
		{ locationGRID: '1234', companyName: 'Company XYZ', addressLine1: '123 Equipment Ave, Suite 333', city: 'Durham', state: 'TN', zipCode: '45645', country: 'CA' },
		{ locationGRID: '1234', companyName: 'Company XYZ', addressLine1: '123 Equipment Ave, Suite 222', city: 'Durham', state: 'NC', zipCode: '66645', country: 'CAN' }],
	pendingLocationDetails: {
		originalFileName: 'abc.xlsx',
		updatedFileName: 'xyz.xlsx'
			  }
};
export const mockAdditionalLocationEmptyResponse: AdditionalLocationListResponse = {
	primaryLocationInfo: {
		primaryLocationGRID: '',
		adminLocationID: '',
		topLevelGrid: '',
		companyName: '',
		addressLine1: '',
		addressLine2: '',
		city: '',
		state: '',
		zipCode: '',
		country: ''
	},
	locationList: [],
	pendingLocationDetails: {
		originalFileName: '',
		updatedFileName: ''
		  }
};
export const mockBusinessAccountSuccessResponse: SubmitRegistrationResponse = {
	registrationStatus: 'approved',
	requestType: RegistrationRequestType.businessAdminUser,
	successMessage: 'Submitted'
};
export const mockBusinessUploadListLabel: UploadFileLabels =
{
	heading: 'Upload New Locations List',
	subHeading: 'Location List Template',
	content: [
		{
			label: '',
			description: ''
		}
	],
	closeIcon: { iconPath: '', altText: '' },
	download: {
		downloadButton: 'Download Template',
		errorMessage: ''
	},
	cancel: 'Cancel',
	upload: 'Upload',
	close: 'Close',
	uploadFile: {
		onLoadIcon: { iconPath: '', altText: '' },
		errorIcon: { iconPath: '', altText: '' },
		successIcon: { iconPath: '', altText: '' },
		dragDropLabel: 'Drag & Drop file here',
		orLabel: 'or',
		uploadButtons: {
			chooseFile: 'Choose File',
			replaceFile: 'Replace File',
			tryAgain: 'Try Again'
		},
		success: 'Upload Submitted'
	},
	errorState:
	{
		messages: [],
		id: '',
		statusCode: 500,
		image: {
			iconPath: '',
			altText: ''
		}
	}
};
export const mockFile1: File = {
	name: 'BusninessRequestAccount.csv',
	size: 10423,
	type: 'text/csv'
} as unknown as File;
export const mockFile2: File = {
	name: 'Corporate_Admin_New Locations_List2.xlsx',
	size: 10,
	type: 'application/vnd.openxmlformats-officedocument.spreadsheetml'
} as unknown as File;
export const mockFile3: File = {
	name: 'Corporate_Admin_New Locations_List2.xlsx',
	size: 100000,
	type: 'application/vnd.openxmlformats-officedocument.spreadsheetml'
} as unknown as File;
export const mockFile4: File = {
	name: 'BusninessRequestAccount.csv',
	size: 102500,
	type: 'text/csv'
} as unknown as File;
export const mockEvent: ModalEvent = {
	state: {
		hidden: false,
		label: 'Upload New Locations List',
		buttons: [
			{ label: 'Cancel', disabled: false, cssClass: 'btn-secondary' },
			{ label: 'Upload', disabled: false, cssClass: 'btn-black' }
		],
		cssClass: 'businessRegistrationUploadModal'
	},
	cta: { label: '', disabled: false, cssClass: 'btn-black' }
};

export const customerSupportLabels = {
	pageheading: 'Impersonate User',
	startCTA: 'Start Session',
	title: 'User Details',
	email: 'Email Address',
	description: 'Enter the email id of the user you want to impersonate, which allows you to access and view the user’s account. You won’t be able to make any changes to their permissions, or data.',
	startSession: 'Are you sure you want to start an impersonating session for the following user?',
	warningNote: 'You are currently viewing the portal as',
	readOnly: 'Read only view.',
	endSession: 'End Session',
	endSessionNote: 'Are you sure you want to end this impersonating session?',
	endSessionCTA: 'No, Continue Session',
	continueSessionCTA: 'Yes, End Session'
};
